import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import { ApiError, NotFoundError } from '../../interfaces/ApiError';

const baseURL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: baseURL,
});

const axiosWithCache = setupCache(axiosInstance)

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle errors consistently
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: ApiError) => {
    if (error.response && error.response.status === 404) {
      // Create a standardized error object for 404s
      const notFoundError: NotFoundError = new Error(error.response.data?.detail || 'Article not found') as NotFoundError;
      notFoundError.name = 'NotFoundError';
      notFoundError.status = 404;
      return Promise.reject(notFoundError);
    }
    return Promise.reject(error);
  }
);

export default axiosWithCache;
